









































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import DeviceApi from "@/module/device/DeviceApi";
import deviceModule from "@/store/module/DeviceModule";
import PaginationTable from "@/component/Table/pagination-table.vue";
import Device, {DeviceShare} from "@/model/Device";
import {DshareForm, DsharePqForm} from '@/form/DeviceForm';
import {DefaultRoleKey} from "@/model/Role";
import _ from "lodash";
import User from "@/model/User";
import UserApi from "@/module/user/UserApi";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import DeviceSharecode from "@/view/device-manage/device/sharecode.vue";

@Component({
  components: {
    PaginationTable,
    CreateDialog,
    DeleteDialog,
    RefreshButton,
    DeviceSharecode,
  },
})
export default class DeviceShareView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private get device(): Device {
    return deviceModule.active
  }

  private pqForm = new DsharePqForm(
      this.device.id
  )

  @Ref()
  private ptable!: PaginationTable

  private refresh() {
    this.ptable?.refresh()
  }

  private async getPaging() {
    return await this.deviceApi.sharePaging(this.pqForm)
  }

  private userApi = Container.get(UserApi)

  private users: Array<User> = []

  private shareForm = new DshareForm()

  @Ref()
  private shareDialog!: CreateDialog

  @Ref()
  private unshareDialog!: DeleteDialog

  private async getUsers() {
    const users: Array<User> = await this.userApi.list(DefaultRoleKey.ROLE_USER)
    this.users = _.filter(users, user => {
      return user.id != this.device.user.id
    })
  }

  private async openShareDialog() {
    this.shareForm.init()
    this.shareForm.deviceId = this.device.id
    await this.getUsers()
    if (!_.isEmpty(this.users))
      this.shareForm.toUserId = this.users[0].id
    this.shareDialog.open()
  }

  private async share() {
    await this.deviceApi.share(this.shareForm)
  }

  private deviceShare = new DeviceShare()

  private handleUnshareClick(deviceShare: DeviceShare) {
    this.deviceShare = deviceShare
    this.unshareDialog.open()
  }

  private async unshare() {
    await this.deviceApi.unshare({
      deviceId: this.deviceShare.id,
      toUserId: this.deviceShare.toUser.id
    })
  }
}
